/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

export const PrivateBlockContext = createContext( {} );
